import { useEffect, useState } from "react";
import { breakpoints } from "../styles";

const useResponse = () => {
  const [breakpoint, setBreakPoint] = useState('t');

  useEffect(() => {
    function handleResize() {
      let currentBreakPoint;
      if (window.innerWidth >= breakpoints.t) {
        currentBreakPoint = 't';
      } else if (window.innerWidth >= breakpoints.m && window.innerWidth < breakpoints.t - 1) {
        currentBreakPoint = 'm';
      } else if (window.innerWidth >= 0 && window.innerWidth < breakpoints.m - 1) {
        currentBreakPoint = 's';
      }
      currentBreakPoint && setBreakPoint(currentBreakPoint);
    }
    window.removeEventListener('resize', handleResize);
    window.addEventListener('resize', handleResize);
    handleResize();
  }, [])
  return breakpoint;
}

export default useResponse;